import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import ComplianceListingPageUI from './ComplianceListingPageUI.js' 

class ComplianceListingPageSF extends Component {  
  constructor(props) {
    super(props)
    this.state = {
      compList: [],
    }
  }

  render() {
    return (
      <ComplianceListingPageUI 
        context={this.props.context}
        compList={this.state.compList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getCompList(context)
  }

  getCompList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/legalLanguage`,
      cacheKey: CacheKeys.CompList(),
      callback: this.getCompListCallBack,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context)
  }

  getCompListCallBack = (response) => {
    this.setState({ compList: response.complianceList })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.CompList()) 
    if (noBusy === 'noBusy') {
      this.getCompList(context)
    } else {
      this.setState({ compList: [] }, () => {
        this.getCompList(context)
      })
    }
  }
}

export default withRouter(ComplianceListingPageSF)
